import { createRoute } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import { PurchasePlanningPage } from '@/pages/purchase-planning/purchase-planning-page';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'purchase-planning',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <PurchasePlanningPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: {
    titleKey: 'PurchasePlanning',
  },
});
